import React from 'react';
import styled from 'styled-components';
import { Row, Col, Card, Skeleton } from 'antd';

interface FreePhotoGridSkeletonProps {
  count?: number;
}

/**
 * Skeleton loader for FreePhoto grid
 */
export const FreePhotoGridSkeleton: React.FC<FreePhotoGridSkeletonProps> = ({ count = 8 }) => {
  return (
    <UI_Wrapper>
      <Row gutter={[16, 16]}>
        {Array.from({ length: count }).map((_, index) => (
          <Col key={index} xs={24} sm={12} md={8} lg={6} xl={6}>
            <Card>
              <Skeleton.Image active style={{ width: '100%', height: '200px' }} />
              <Skeleton active paragraph={{ rows: 2 }} style={{ marginTop: 12 }} />
            </Card>
          </Col>
        ))}
      </Row>
    </UI_Wrapper>
  );
};

const UI_Wrapper = styled.div`
  padding: 16px;
`;
